function openVideo(event) {
    if (event.detail.dataset.popup === 'video-popup') {
        const popup = document.querySelector(`#${event.detail.dataset.popup}`)
        const videoIframe = event.detail.dataset.video
        const videoPreview = event.detail.dataset.preview
        const video = popup.querySelector('.js-show-video-iframe')
        const preview = popup.querySelector('.js-preview')
        preview.src = videoPreview
        video.innerHTML = videoIframe
        loadingLazy(video.querySelector('iframe'))
    }
}

function loadingLazy(iframe) {
    iframe.setAttribute('loading', 'lazy')
}

function closeVideo(popup) {
    if (popup.detail) {
        const video = popup.detail.querySelector('.js-show-video-iframe')
        if (video) {
            removeVideoIframe(video)
            showVideoPreview(video)
        }
    }
}

function removeVideoIframe(video) {
    const iframe = video.querySelector('iframe')
    video.removeChild(iframe)
}

function showVideoPreview(video) {
    const wrapper = video.closest('.js-show-video-wrapper');
    const preview = wrapper.querySelector('.js-hidden-preview');

    video.classList.add('hidden');
    preview.classList.remove('hidden');
}


function playButton(e) {
    const target = e.target;
    if (target.closest('.js-play-button')) {
        const wrapper = target.closest('.js-show-video-wrapper');
        const preview = wrapper.querySelector('.js-hidden-preview');
        const hideVideo = wrapper.querySelector('.js-show-video-iframe');

        hideVideo.classList.remove('hidden');
        preview.classList.add('hidden');
        hideVideo.querySelector('iframe').src += '?autoplay=1'
    }
}

document.addEventListener('click', playButton);
document.addEventListener('popup:opened', openVideo)
document.addEventListener('popup:closed', closeVideo)
